/* eslint-disable no-unused-vars */
import React, { ReactNode, useState } from 'react';
import style from './circleClose.module.scss';
import cx from 'classnames';

export default function CircleClose({
  children,
  className,
  onClick,
}: {
  children: ReactNode;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
}) {
  const [isMousePressed, setIsMousePressed] = useState(false);

  return (
    <div
      onClick={onClick}
      onMouseDown={() => {
        setIsMousePressed(true);

        const listener = () => {
          setIsMousePressed(false);
          document.removeEventListener('mouseup', listener, true);
        };

        document.addEventListener('mouseup', listener, true);
      }}
      className={cx(
        style.container,
        className,
        isMousePressed ? style.isPressed : ''
      )}
    >
      {children}
    </div>
  );
}
